import { render, staticRenderFns } from "./GetSupsisRecordById.vue?vue&type=template&id=6513406f"
import script from "./GetSupsisRecordById.vue?vue&type=script&lang=js"
export * from "./GetSupsisRecordById.vue?vue&type=script&lang=js"
import style0 from "./GetSupsisRecordById.vue?vue&type=style&index=0&id=6513406f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports